module.exports = __webpack_public_path__ + "img/html.1ff6b18f.png";